import React , {useEffect, useState} from 'react';
import cwsLogo from "../../asserts/images/Landing Page - Middle Placeholder Image (4975x2767px).png";
import "./layout.css";
import axios from "../../axios-order";

const LandingPage = () => {
  const [logoUrl, setLogoUrl] = useState(null);
  
  useEffect( () => {
    const businessEntityId = localStorage.getItem('business_entity_id');

    // Existing tally URL call
    axios.get(`cws_tally_uploads/get_url/${businessEntityId}`)
    .then( res => {
      let status = res.data.status;
      let urlForTally = res.data.url;
      localStorage.setItem("UploadTallyStatus" , status );
      localStorage.setItem("urlForTally" , urlForTally );
    } )
    .catch( () => {
      localStorage.setItem("UploadTally" , "false");
      localStorage.setItem("urlForTally" , "" );
    } )

    // Step 1: Check if CA firm
    axios.get(`/check_if_ca_firm_or_not/${businessEntityId}`)
    .then( res => {
      const isCaFirm = res.data?.is_ca_firm === true;
      localStorage.setItem("is_ca_firm", isCaFirm ? "true" : "false");

      // Step 2: Only call get_active_quotas if is_ca_firm is true
      if (isCaFirm) {
        axios.get(`/get_active_quotas/${businessEntityId}`)
        .then( quotaRes => {
          const records = quotaRes.data?.records || [];
          localStorage.setItem("quota_data", JSON.stringify(records));
        })
        .catch( () => {
          localStorage.setItem("quota_data", JSON.stringify([]));
        })
      } else {
        localStorage.setItem("quota_data", JSON.stringify([]));
      }
    })
    .catch( () => {
      localStorage.setItem("is_ca_firm", "false");
      localStorage.setItem("quota_data", JSON.stringify([]));
    })

  } , [] )

   // Logo fetch
  // useEffect(() => {
  //   getLogo();
  // }, []);

  useEffect(() => {
    getLogo();
    window.addEventListener('logoUpdated', getLogo);
    return () => {
      window.removeEventListener('logoUpdated', getLogo);
    };
  }, []);

const getLogo = () => {
  axios.get(`get_customer_logo/${localStorage.getItem("business_entity_id")}/${false}`)
    .then((res) => {
      if (res.data.status && res.data.logo_url) {
        // setLogoUrl(res.data.logo_url);  // ← Use logo_url directly
         setLogoUrl(res.data.logo_url + '?t=' + Date.now()); 
      } else {
        setLogoUrl(cwsLogo);
      }
    })
    .catch((err) => {
      console.error("Failed to fetch logo:", err);
      setLogoUrl(cwsLogo);
    });
};
  
  return (
    <>
      {/* ---Welcome Message--- */}
      
      <div className="WelcomeMessage" style={{ fontFamily: 'Lato, sans-serif' }}>
        <img src={cwsLogo} height={250} width={450} alt="Loading" />
        <h3 style={{ 
           fontFamily: 'Lato, sans-serif', 
            fontWeight: 400,
            textTransform: 'none',
            marginTop: '2rem',
            textAlign: 'center'
        }}>
          Welcome to ARC - cash release and compliance management simplified
        </h3>
      </div>

    </>
  )
};


export default LandingPage;